import {
  dangerColor,
  whiteColor,
} from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react.jsx";

type InlineErrorProps = {
  text?: string;
};

function InlinePageError({ text = "Unknown error" }: InlineErrorProps) {
  if (!text) {
    return null;
  }
  return (
    <div
      style={{
        color: whiteColor,
        background: dangerColor[0],
        padding: 12,
      }}>
      {text}
    </div>
  );
}

export default InlinePageError;
